export const getQRCode = async (content: string) => {
  const QRCode = await import('qrcode');
  const qrcode = await QRCode.toDataURL(content);
  return qrcode;
};
